<template>
  <div>
    <label v-if="!templateEditing" class="vform-editor-label section">Question</label>
    <original-language-viewer
        v-if="!templateEditing && $store.getters.getSelectedFormLanguage !== 'Unknown'"
        :original-text="element.label.dix['Unknown']"
        class="mb-2"
    />
    <div class="vform-label lighter white non-bold">{{ $store.getters.getSelectedFormLanguage }}</div>
    <div
        v-if="!templateEditing"
        :key="forceReRenderKey"
        class="dflex"
    >
      <div class="col p-0">
                <textarea
                    v-model="element.label.dix[$store.getters.getSelectedFormLanguage]"
                    :title="element.label.dix['Unknown']"
                    class="form-text v-form-label form-text-dark"
                    rows="300"
                    type="text"
                />
        <div class="col row mt-2">
          <div class="col-12 pl-0 dflex">
            <label :for="'chkNoQuestion' + $vnode.key" class="container vform-editor-body"
            >{{ $t("noQuestion") }}
              <input
                  :id="'chkNoQuestion' + $vnode.key"
                  v-model="element.noQuestion"
                  type="checkbox"
              >
              <span class="checkmark"/>
            </label>
          </div>
        </div>

        <!-- :placeholder="
                key === 'Unknown' ? $t('Question') : key + ' ' + $t('question')
            " -->

        <!--ANSWERS-->
        <label class="vform-editor-label section">Answers</label>
        <label class="vform-editor-label section" style="float: right"
        >Correct</label
        >
        <div
            v-for="(item, index4) in element.options"
            :key="index4 + 98239283 + forceReRenderKey"
            class="dflex mb-3 pb-2 border-bottom-light"
        >
          <div class="col pl-0 pr-0 dflex">
            <div class="col pl-0">
              <div class="w-100" />
              <original-language-viewer
                  v-if="!templateEditing && $store.getters.getSelectedFormLanguage !== 'Unknown'"
                  :original-text="item.text.dix['Unknown']"
                  class="mb-2"
              />
              <div class="w-100" />
              <div class="vform-label lighter white non-bold">{{ $store.getters.getSelectedFormLanguage }}</div>
              <div class="w-100" />
              <div class="textarea-container">
                <textarea
                    v-model="item.text.dix[$store.getters.getSelectedFormLanguage]"
                    :title="item.text.dix['Unknown']"
                    class="form-text v-form-label form-text-dark mb-2"
                    rows="300"
                    type="text"
                />
                <div
                    class="icon-delete-option"
                    style="position: absolute; top: -1px; right: 0;"
                    @click="removeOption(index4)"
                >
                  <icon :size="'1.8'" type="fat-square-minus"/>
                </div>
              </div>
              <div class="w-100 pl-0 pr-0">
                <div v-if="true" class="col-12 dflex row">
                  <label
                      :for="'chkPreSelected' + $vnode.key + index4"
                      class="container"
                      style="padding-left: 5px !important"
                  ><div class="ml-4">{{ $t('isPreSelected') }}</div>
                    <input
                        :id="'chkPreSelected' + $vnode.key + index4"
                        v-model="item.isPreSelected"
                        type="checkbox"
                    >
                    <span class="checkmark"/>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-auto pl-0 pr-0">
              <div class="col-12 dflex row">
                <checkbox-widget :class="'pl-1'" :initial-value="item.isCorrectAnswer"
                                 :label-for="'chkCorrect' + $vnode.key + index4"
                                 @change="(val) => { item.isCorrectAnswer = val; }"/>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 mt-1 text-right col" style="padding-right: 34px">
          <span @click="addOption($store.getters.getSelectedFormLanguage)">
              <icon :size="'2.0'" type="fad-square-plus"/>
          </span>
        </div>
      </div>
    </div>
    <template v-if="!element.emphasized">
      <label class="vform-editor-label section">Background Color</label>
      <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)" />
      <color-picker-and-field
          v-else
          :field-background-color="element.backgroundColor"
          @saveColor="(color) => {setItemColor('backgroundColor', color)}"
          @unsetColor="setItemColor('backgroundColor', null)"
      />
      <label class="vform-editor-label section">Font Color</label>
      <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)" />
      <color-picker-and-field
          v-else
          :field-background-color="element.fontColor"
          @saveColor="(color) => {setItemColor('fontColor', color)}"
          @unsetColor="setItemColor('fontColor', null)"
      />

      <div
          v-if="(!selectedTemplate.fontColor && !selectedTemplate.backgroundColor) && (element.backgroundColor || element.fontColor)"
          class="settings-button d-inline-block mt-2"
          @click="element.backgroundColor = null; element.fontColor = null;">
        {{ $t('resetColor') }}
      </div><br >
    </template>

    <label v-if="!templateEditing" class="vform-editor-label section">Options</label>
    <!--ADD DIX TRANSLATION-->
    <div v-if="!templateEditing" class="col row mt-2">
      <div class="col-12 pl-0 dflex">
        <label :for="'chkEmphasized' + $vnode.key" class="container vform-editor-body"
        >{{ $t("emphasized") }}
          <input
              :id="'chkEmphasized' + $vnode.key"
              v-model="element.emphasized"
              type="checkbox"
          >
          <span class="checkmark"/>
        </label>
      </div>
      <div class="col-12 pl-0 dflex">
        <label :for="'chkRequired' + $vnode.key" class="container vform-editor-body"
        >{{ $t("isRequired") }}
          <input
              :id="'chkRequired' + $vnode.key"
              v-model="element.isRequired"
              type="checkbox"
          >
          <span class="checkmark"/>
        </label>
      </div>
      <div class="col-12 pl-0 dflex">
        <label :for="'chkCorrect' + $vnode.key" class="container vform-editor-body"
        >{{ $t("validateCorrectness") }}
          <input
              :id="'chkCorrect' + $vnode.key"
              v-model="element.validateCorrectness"
              type="checkbox"
          >
          <span class="checkmark"/>
        </label>
      </div>
    </div>
    <!--DIX-->
    <!--FOR EACH TRANSLATION ONE FIELD-->
  </div>
</template>

<script>
import Icon from "@/components/Icon";
import {vFormControls, placeholders} from "@/enum";
import vFormElementMixin from "@/components/vForm/vFormElementMixin.js";
import CheckboxWidget from "@/components/widgets/editors/Checkbox.vue";
import {v4 as uuidv4} from "uuid";
import SetByTemplate from "@/components/vForm/SetByTemplate.vue";
import ColorPickerAndField from "@/components/widgets/editors/ColorPickerAndField.vue";
import OriginalLanguageViewer from "@/components/vForm/OriginalLanguageViewer.vue";
export default {
  name: "vFormMULTIPLE_CHOICE",
  components: {
    OriginalLanguageViewer,
    ColorPickerAndField,
    Icon,
    CheckboxWidget,
    SetByTemplate,
  },
  mixins: [vFormElementMixin],
  props: {
    element: {type: Object, required: true},
    stepNo: {type: Number, required: true},
    organizationId: {type: String, default: ""},
  },
  data() {
    return {
      forceReRenderKey: 0,
      editImage: "",
      vFormControls: vFormControls,
      placeholders: placeholders,
    };
  },
  watch: {
    element: {
      deep: true,
      handler() {
      },
    },
  },
  beforeMount() {
    if (!this.element.options) {
      this.addOption("Unknown");
    }
    if(!this.element.noQuestion) {
      this.$set(this.element, "noQuestion", false)
    }
  },
  methods: {
    removeOption(index) {
      this.element.options.splice(index, 1);
    },
    addOption(lang) {
      if (!this.element.options) {
        this.$set(this.element, "options", []);
      }
      this.element.options.push({
        uuid: uuidv4(),
        isCorrectAnswer: false,
        isChecked: false,
        isPreSelected: false,
        text: {
          dix: {
            [lang]: "",
          },
          imageDix: {
            [lang]: "",
          },
        },
      });
      this.forceReRenderKey++;
    },
  },
};
</script>

<style lang="scss" scoped>
.border-bottom-light {
  border-bottom: 1px solid rgba(255,255,255,0.1);
}
.textarea-container {
  position: relative;
}
.icon-delete-option {
  transition: all 300ms ease;
  &:hover {
    color: $highlight;
  }
}
</style>